import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Dietitian } from '../../../data/dietitian/domain/dietitian';
import { MessageFacade } from './message.facade';
import { ConversationModel } from './message.models';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  providers: [MessageFacade],
})
export class MessageComponent {
  @Input() loading = false;
  @Input() updating = false;
  @Input() emptyMessage = 'Aucune conversation ...';
  @Input() displayMarkAsReadButton = true;
  @Input() displayMarkAsReadSubButton = true;
  @Input() conversations: ConversationModel[];
  @Input() origin = 'list';
  @Input() dietitian: Dietitian | undefined;
  @Output() refreshConversation = new EventEmitter<void>();
  @Input() mode: 'patient' | 'dietitian' = 'dietitian';
  @Output() refresh = new EventEmitter<void>();

  public error?: string;
  public selectedConversation?: ConversationModel;

  constructor(private facade: MessageFacade) {
    // nothing
  }

  async markMessagesAsRead() {
    this.updating = true;
    if (this.mode === 'patient') {
      await this.facade.markPatientConversationsAsRead();
    } else {
      await this.facade.markDietitianConversationsAsRead();
    }
    this.refreshConversation?.emit();
    this.updating = false;
  }

  openConversation(conversation: ConversationModel) {
    console.log('👀 conversation', conversation.id.toString());
    this.selectedConversation = conversation;
  }

  messageBack() {
    if (this.conversations.length > 0) {
      for (let i = 0; i < this.conversations.length; i++) {
        if (this.conversations[i] === this.selectedConversation) {
          this.selectedConversation =
            i + 1 < this.conversations.length
              ? this.conversations[i + 1]
              : this.conversations[i];
          break;
        }
      }
    }
  }

  messageForward() {
    if (this.conversations.length > 0) {
      for (let i = this.conversations.length - 1; i >= 0; i--) {
        if (this.conversations[i] === this.selectedConversation) {
          this.selectedConversation =
            i - 1 >= 0 ? this.conversations[i - 1] : this.conversations[i];
          break;
        }
      }
    }
  }

  messageClose() {
    this.selectedConversation = undefined;
  }
}
